import React from 'react';
import TestPayment from './TestPayment';

function App() {
  return (
    <div className='App'>
      <TestPayment />
    </div>
  );
}

export default App;
